import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ManagerContext } from '../../contexts/ManagerContext';
import { UiContext } from '../../contexts/UiContext';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import ThreadsContainer from '../chat/ThreadsContainer';

import ListItemIcon from '@mui/material/ListItemIcon';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import LoginIcon from '@mui/icons-material/Login';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';





export default function MenuContent( { open, handleDrawerClose } ) {
  const { openLogin, setOpenLogin, openContactForm } = React.useContext(UiContext);
  const { currentUser, logout, setCurrentPage, currentPage } = React.useContext(ManagerContext);
  const [ selected, setSelected ] = React.useState(0);

  const navigate = useNavigate();
  const handelClickMain = (index) => {
    handleDrawerClose(true)
    console.log(index);
    if (index === 0){
      if (currentUser){
        logout()
      }else{
        setOpenLogin(!openLogin)
      }
    }
    if(index!==3) setSelected(index)
    if (index === 1){
      navigate('/')
      setCurrentPage(0)
    }else if (index === 2){
      setCurrentPage(1)
      navigate('/donate')
    } else if (index === 3){
      openContactForm()
    }
  }

  React.useEffect( () => {
    setSelected(currentPage+1)
  }, [currentPage] )

  const mainListItems = [
    { text: currentUser?'Logout': 'Sign Up / Login', icon: currentUser?<LogoutRoundedIcon />: <LoginIcon /> },
    { text: 'Chat', icon: <HomeRoundedIcon /> },
    { text: 'Donation', icon: <VolunteerActivismIcon /> },
    { text: 'Contact', icon: <ContactPageIcon /> },
  ];
  
  const secondaryListItems = [
    
    // { text: 'Settings', icon: <SettingsRoundedIcon /> },
    // { text: 'About', icon: <InfoRoundedIcon /> },
    // { text: 'Feedback', icon: <HelpRoundedIcon /> },
  ];

  const filteredMainListItems = mainListItems.filter((_, index) => index !== 0 || currentUser);
  

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'flex-start', overflowY: 'auto', overflowX: 'hidden' }}>
      
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block', mb: index === 0 ? 2 : 0 }}>
            <ListItemButton selected={index === selected && index !== 0}
              onClick={() => handelClickMain(index)}>
              <ListItemIcon sx={{ color: 'white' }}>{item.icon}</ListItemIcon>
              {/* <ListItemText primary={item.text} sx={{ color: 'white' }} /> */}
              <Typography variant="inherit" noWrap>
                {item.text}
              </Typography>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {currentPage===0 && <ThreadsContainer open={open} />}
      </Stack>
  );
}